let config = {
  settings: {},
};

// Get the CSRF token from the cookie
export const getCsrfToken = () => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; XSRF-TOKEN=`);
  if (parts.length === 2) {
    return parts.pop().split(";").shift();
  }
};

export const getSourceCode = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const availableSourceCodes = config.settings.sourceCodes;
  const utmMedium = queryParams.get("utm_source");
  let result = "";
  let sourceCodeLines = [];
  let sourceCodeLine = [];

  if (availableSourceCodes && utmMedium)
  {
      sourceCodeLines = availableSourceCodes.split('|');
      if (sourceCodeLines.length > 0)
      {
        for (let i = 0; i < sourceCodeLines.length; i++) {
          sourceCodeLine = sourceCodeLines[i].split('=');
          if (sourceCodeLine.length > 1)
          {
              if (sourceCodeLine[0] == utmMedium)
              {
                  result = sourceCodeLine[1];
                  break;
              }
          }
        }
      }
  }
  
  return result;
}

export default config;
